import { cookiesStorage } from '$utils/services/cookiesStorage'

export const isCookiesLawAcepted = () => {
  return cookiesStorage.getCookie('cookiesLaw')
}



// WEBPACK FOOTER //
// ./src/services/user/cookiesLaw/isCookiesAcepted.service.ts